import {Api, Method} from "../../api/api";
import {showToast} from "../../toast";
import {renderElement} from "../../utils/common";
import {CLOSE_CLASS_NAME, TAG_CLASS_NAME} from "../constants";
import {getUpdateTagModal} from "../template";

export class UpdateTag {
  private element: HTMLElement;
  private modalElement: HTMLElement | null;
  private formElement: HTMLFormElement | null;
  private radioElements: HTMLInputElement[];
  private nameElement: HTMLInputElement | null;

  private api = new Api();

  private rgbToHex(rgb: string): string {
    const match = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    if (!match) return rgb;
    const [_, r, g, b] = match;
    return `#${(+r).toString(16).padStart(2, '0')}${(+g).toString(16).padStart(2, '0')}${(+b).toString(16).padStart(2, '0')}`;
  }

  constructor() {
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.modalClickHandler = this.modalClickHandler.bind(this);
    this.formSubmitHandler = this.formSubmitHandler.bind(this);

    document.addEventListener(`click`, this.onDocumentClick);
  }

  renderModal() {
    this.modalElement = renderElement(document.body, getUpdateTagModal({
      tagId: this.element.dataset.id ? +this.element.dataset.id : 0,
      name: this.element.dataset.name?.trim() ?? "",
      color: this.rgbToHex(this.element.style.backgroundColor)
    })) as HTMLElement | null;

    if (this.modalElement) {
      this.formElement = this.modalElement.querySelector(`form`);

      if (!this.formElement) return;

      this.nameElement = this.formElement.querySelector(`input[type=text]`);
      this.radioElements = Array.from(this.formElement.querySelectorAll(`input[type=radio]`));

      this.formElement.addEventListener(`submit`, this.formSubmitHandler);
      this.modalElement.addEventListener(`click`, this.modalClickHandler);
    }
  }

  private isNameValid() {
    if (!this.nameElement) return false;
    return this.nameElement.value.trim().length !== 0;
  }

  private isColorChecked() {
    if (this.radioElements.length === 0) return false;

    return this.radioElements.some((radio) => radio.checked);
  }

  /**
   *  Получение данных формы
   */
  private getTagData() {
    return {
      id: this.element.dataset.id ? +this.element.dataset.id : 0,
      name: this.nameElement?.value.trim() ?? "",
      color: this.radioElements.find((radio) => radio.checked)?.value ?? "",
    };
  }

  /**
   *  Отправка запроса и создание метки, в случае успешной передачи данных.
   */
  async #postData() {
    const data = this.getTagData();
    const {name, color} = data;

    const {code, answer} = await this.api.customQuery(this.formElement?.action ?? "" , {method: Method.POST, query: JSON.stringify(data)}); // TODO: Поменять на POST

    if (code === 200) {
      this.updateTag(name, color);
      this.#removeModal();
    } else {
      showToast(answer.text);
    }
  }

  private updateTag(name: string, color: string) {
    const nameElement = this.element.querySelector('span');

    this.element.dataset.name = name;
    this.element.style.backgroundColor = color;

    if (!nameElement) return;

    nameElement.textContent = name;
  }

  #removeModal() {
    if (!this.modalElement) return;

    this.modalElement.remove();
    this.modalElement = null;
  }

  /**
   *  Слушатель отправки формы и в случае её валидности, отправка данных
   */
  async formSubmitHandler(event) {
    event.preventDefault();

    if (this.isNameValid() && this.isColorChecked()) {
      await this.#postData();
    } else {
      this.formElement!.classList.add(`form--error`);
    }
  }

  /**
   *  Слушатель клика на модальном окна создания метки
   */
  modalClickHandler(event: PointerEvent) {
    const target = event.target as HTMLElement | null;
    if (target && target.classList.contains(CLOSE_CLASS_NAME)) {
      this.#removeModal();
    }
  }

  onDocumentClick(evt: PointerEvent) {
    const target = evt.target as HTMLElement | null;

      if (target && (target.classList.contains(TAG_CLASS_NAME) || target?.closest(`.${TAG_CLASS_NAME}`))) {
      this.element = target.classList.contains(TAG_CLASS_NAME) ? target : target.closest(`.${TAG_CLASS_NAME}`)!;

      if (this.element.dataset.edit && this.element.dataset.edit === "true") {
        this.renderModal();
      }
    }
  }
}
